import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import IconContainer from '../../common/IconContainer';
const HubspotFormWrapper = ({ children, removeContainer, containerTag, textColor, backgroundColor, }) => {
    const theme = useTheme();
    const style = useMemo(() => (Object.assign({ color: theme.colors[textColor] }, (containerTag === 'newsletter'
        ? {
            paddingTop: 72,
            paddingBottom: 72,
            borderBottom: `1px solid ${theme.colors.grey_4}`,
            overflow: 'hidden',
        }
        : {}))), [containerTag, textColor, theme.colors]);
    if (removeContainer)
        return children;
    return (_jsx(IconContainer, { pageTag: containerTag, styles: {
            container: style,
            content: { padding: 0, position: 'static' },
        }, containerBackgroundColor: theme.colors[backgroundColor], children: children }));
};
export default HubspotFormWrapper;
